import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../firebase/client";
import type { Lineups } from "../types/teams.types";

export function useLineups(fixtureId: number | null): Lineups | null {
	const [lineups, setLineups] = useState<Lineups | null>(null);

	useEffect(() => {
		if (!fixtureId) return;

		const unsubscribe = onSnapshot(
			doc(db, "fixtures", String(fixtureId)),
			(snap) => {
				if (snap.exists()) {
					setLineups((snap.data() as { lineups: Lineups }).lineups);
				} else {
					setLineups(null);
				}
			},
		);

		return unsubscribe;
	}, [fixtureId]);

	return lineups;
}
